import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


// @ actions
import { initFilter, setApplied } from 'actions/filters'

function withFiltersFeatures(FiltersWrapper) {

    class FiltersConnector extends Component {
        componentWillMount() {
            const { filtersId, initFilter } = this.props;
            initFilter(filtersId);
        }

        getFilterComponentsWithExtraProps = children => this.getChildrenArray(children).map(this.addExtraProps)

        getChildrenArray = children => children.props.children ? React.Children.toArray(children.props.children) : [];

        addExtraProps = (component, i) => {
            if (typeof(component) === "string") {
                return component
            } else {
                const filterId = component.props.filterId;
                let extraProps = {};
                if (filterId) {
                    extraProps = {
                        immFilter: this.props.immFilters && this.props.immFilters.get(filterId),
                        filtersId: this.props.filtersId,
                        key: i,
                    }
                }
                return React.cloneElement(
                    component,
                    {...component.props, ...extraProps},
                    this.getFilterComponentsWithExtraProps(component)
                )
            }
        }

        render() {
            return <FiltersWrapper {...this.props} renderFilters={this.getFilterComponentsWithExtraProps}/>;
        }
    }

    function getDisplayName(FiltersWrapper) {
        return FiltersWrapper.displayName || FiltersWrapper.name || 'Component';
    }

    FiltersConnector.displayName = `ConnectToFiltersFeatures(${getDisplayName(FiltersConnector)})`;

    FiltersConnector.propTypes = {
        filtersId: PropTypes.string.isRequired,
        initFilter: PropTypes.func.isRequired,
        immFilters: PropTypes.object,
    };
    
    return connect(
        (state, ownProps) => ({
            immFilters: state.filters.get(ownProps.filtersId)
        }),
        {
            initFilter,
            setApplied
        }
    )(FiltersConnector);
}

export default withFiltersFeatures;